export default {
  updateToken: (state, value) => {
    state.token = value;
    localStorage.accessToken = value;
  },
  updateUser: (state, value) => {
    state.user = value;
    localStorage.user = JSON.stringify(value);
  },
  updateKey_: (state, value) => {
    state.key_ = value;
  },
  // 更新菜单栏购物车数量
  updateCartCount: (state, value) => {
    state.userCartCount = value;
    localStorage.setItem('userCartCount', value);
  }
};